import {
  useIsMergeReasonsNewUXEnabled,
  useIsT3DuplicateReasonsEnabled,
} from '@modules/common/hooks';
import {
  mapCategoryToEdgeCategory,
  mapEdgeCategoryToCategory,
} from '@modules/common/utils';
import { MergeReasonSuggestionsDrawerV2 } from '@modules/taxonomy/components/MergeReasonSuggestionsDrawerV2';
import {
  MergeSuggestionDetailsDrawer,
  MergeSuggestionDetailsDrawerProps,
} from '@modules/taxonomy/components/MergeSuggestionDetailsDrawer/MergeSuggestionDetailsDrawer';
import { MarkReasonsAsDuplicateDrawer } from '@modules/taxonomyV2/components/MarkReasonsAsDuplicate';

export const MergeReasonSuggestionDrawerContainer = (
  props: MergeSuggestionDetailsDrawerProps,
) => {
  const isT3DuplicateReasonsEnabled = useIsT3DuplicateReasonsEnabled();

  const isMergeReasonsNewUXEnabled = useIsMergeReasonsNewUXEnabled();

  if (isMergeReasonsNewUXEnabled) {
    return <MergeReasonSuggestionsDrawerV2 {...props} />;
  }

  if (isT3DuplicateReasonsEnabled) {
    return (
      <MarkReasonsAsDuplicateDrawer
        {...props}
        activeMergeSuggestion={{
          ...props.activeMergeSuggestion,
          category: mapCategoryToEdgeCategory(
            props.activeMergeSuggestion.category,
          ),
          suggestedLabelsToMerge:
            props.activeMergeSuggestion.suggestedLabelsToMerge.map(
              (suggestedLabel) => ({
                ...suggestedLabel,
                category: mapCategoryToEdgeCategory(suggestedLabel.category),
              }),
            ),
        }}
        onAddSuggestion={(suggestion) =>
          props.onAddSuggestion({
            ...suggestion,
            category: mapEdgeCategoryToCategory(suggestion.category),
          })
        }
        onUpdateCategory={(category) => {
          const mappedCategory = mapEdgeCategoryToCategory(category);
          mappedCategory && props.onUpdateCategory(mappedCategory);
        }}
      />
    );
  }

  return <MergeSuggestionDetailsDrawer {...props} />;
};
